"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("horizontal-bar", require("../../tests/InBody/InBodyHorizontalBar.vue").default);

exports.default = {
  props: ["item", "groupNames"],

  methods: {
    getGroupName: function getGroupName(index) {
      var filteredGroups = Array.from(new Set(Object.values(this.groupNames)));
      return filteredGroups ? filteredGroups[index] : null;
    },
    getVFAText: function getVFAText(index) {
      var groupName = this.getGroupName(index);
      var text = "Visceral Fat Area";

      if (groupName) {
        text += " (" + groupName + ")";
      }

      return text;
    },
    getInvalidText: function getInvalidText(result) {
      var label = result.text;

      var text = label;
      text += result.groupName ? " (" + result.groupName + ")" : "";

      return text;
    },
    getRandomKey: function getRandomKey() {
      return Fn.random("");
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/InBodyChart.vue
// module id = kd0n
// module chunks = 0 1